import Factory from "@Shared/Factory";
import { ADD_SUPPLIER, DELETE_SUPPLIER, UPDATE_LIBRARY, } from "@Store/Actions/Suppliers/companies";
import { set } from "object-path";
export default (state = [], { type, data }) => {
    switch (type) {
        case DELETE_SUPPLIER:
            return state.filter((object) => object.id !== data);
        case ADD_SUPPLIER:
            const supplier = Factory.Supplier(data);
            return [...state.filter(({ id }) => id !== supplier.id), supplier];
        case UPDATE_LIBRARY:
            const currentSupplier = state.find(({ id }) => id === data.id);
            const supplierData = currentSupplier.data;
            set(supplierData, data.effects, data.value);
            return [
                ...state.filter(({ id }) => id !== data.id),
                Factory.Supplier({
                    ...supplierData,
                }),
            ];
    }
    return state;
};
